export const sanityClientConfig = {
  // replace this id with the one you find in /studio/sanity.json
  projectId: 'fohcg9qs',
  // make sure that the dataset name is the same as the one in /studio/sanity.json
  dataset: 'production',
  useCdn: false
}
